export default "/assets/images/home-wrecker4.png?a50613737200eb52f641db1fa17b01c2";